import OrganizationReport from "./OrganizationReport";

export default OrganizationReport;